import OpelCorsa from "../assets/images/opelcorsa.jpg";
import SpaceStar from "../assets/images/MITS-SPACE.png";
import Peugeot208 from "../assets/images/p-208.jpg";
import Peugeot108 from "../assets/images/108-p.webp";
import CitroenC1 from "../assets/images/C1.jpeg";
import Micra from "../assets/images/PHOTO-2022-01-23-14-12-06.jpg";
import Panda from "../assets/images/PHOTO-2022-01-23-14-12-05-1.jpg";
import Stonic from "../assets/images/KIA-STONIC-Manual-1.png";
import i20 from "../assets/images/HYUNDAI-i20-Manual-1.png";
import quashqai from "../assets/images/quashqai.jpg";
import duster from "../assets/images/duster.jpeg";
import crossland from "../assets/images/opel-crossland.webp";
import clio from "../assets/images/RENAULT-CLIO-Manual-1.png";
import rio from "../assets/images/KIA-RIO-Auto-1.png";
import Wrangler5D from "../assets/images/jeep-wr-5d.png";
import WranglerCabrio from "../assets/images/Jeep-wrangler-cabrio.png";
import Discovery from "../assets/images/land-rover.webp";
import Wrangler from "../assets/images/JEEP-WRANGLER-Auto-1.png";
import WranglerSahara from "../assets/images/JEEP-WRANGLER-1.png.webp";
import Berlingo from "../assets/images/CITROEN-BERLINGO-Auto.png.webp";
import Doblo from "../assets/images/FIAT-DOBLO-Manual-1.png.webp";
import TRoc from "../assets/images/vw-t-roc.png";
import C1Cabrio from "../assets/images/PHOTO-2022-01-23-14-12-11.jpg.webp";
import MiniCooper from "../assets/images/MINI-COOPER-Cabrio-Auto-1.png.webp";
import Fiat500 from "../assets/images/FIAT-500-Auto-Cabrio-1.png.webp";
import SmartForTwo from "../assets/images/SMART-ForTwo-Cabrio-Manual-4.png.webp";
import SmartForTwoAuto from "../assets/images/SMART-ForTwo-Cabrio-Auto-2.png.webp";
import Buggy800 from "../assets/images/CF-MOTO-BUGGY-800cc-1.png.webp";
import Buggy550 from "../assets/images/beach_buggy.png";
import ATV450 from "../assets/images/5_14f72470629695dca3487f902b2c012f.png.webp";
import RangeSport from "../assets/images/PHOTO-2022-01-22-12-09-42.jpg";
import C3Aircross from "../assets/images/PHOTO-2022-01-25-15-13-22.jpg";
import C3 from "../assets/images/PHOTO-2022-01-22-11-45-44-1.jpg";
import C4Cactus from "../assets/images/PHOTO-2022-01-22-11-51-47.jpg";
import MiniCountryman from "../assets/images/PHOTO-2022-01-25-15-13-22-1.jpg";
import Glb2022 from "../assets/images/MERCEDES-BENZ-GLB-2022-Automatic-1.png";
import Gla2023 from "../assets/images/253_9060274dbdc76eb56b4a456a70298fff.png";
import BmwX1 from "../assets/images/BMW-X1-2023-Automatic.png";
import BmwX2 from "../assets/images/BMW-X2-Automatic-1.png";
import Sportage from "../assets/images/KIA-SPORTAGE-Auto-1.png";
import Cayenne from "../assets/images/PORSCHE-CAYENNE-Auto-1.png";

export const categories = [
  'ATV-Quads',
  'Cabrio',
  'Electric',
  'Economy',
  'Jeep Wrangler',
  'Jeep-SUV-Family',
  'Mini Vans',
  'Motorbikes',
  'Special',
  'Standard'
];

export const carData = {
  economy: [
    { 
      id: "opel_corsa_automatic",
      name: "OPEL CORSA Automatic (or Similar)", 
      image: OpelCorsa, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "50L", 
      price: 65,
      exteriorColor: "White",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "mitsubishi_space_star_automatic",
      name: "MITSUBISHI SPACE STAR Automatic (or Similar)", 
      image: SpaceStar, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "45L", 
      price: 65,
      exteriorColor: "Silver",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "peugeot_208_automatic",
      name: "Peugeot 208 Automatic (or Similar)", 
      image: Peugeot208, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "48L", 
      price: 65,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "peugeot_108_automatic",
      name: "Peugeot 108 Automatic (or Similar)", 
      image: Peugeot108, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Red",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "peugeot_108_manual",
      name: "Peugeot 108 Manual (or Similar)", 
      image: Peugeot108, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Red",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "citroen_c1_automatic",
      name: "Citroen C1 Automatic (or Similar)", 
      image: CitroenC1, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "citroen_c1_manual",
      name: "Citroen C1 Manual (or Similar)", 
      image: CitroenC1, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "46L", 
      price: 65,
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "nissan_micra_automatic",
      name: "NISSAN MICRA Automatic (or Similar)", 
      image: Micra, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "nissan_micra_manual",
      name: "NISSAN MICRA Manual (or Similar)", 
      image: Micra, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "fiat_panda_manual",
      name: "FIAT PANDA Manual (or Similar)", 
      image: Panda, 
      persons: 4, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 45,
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    }
  ],
  electric: [
    { 
      id: "opel_corsa_automatic",
      name: "OPEL CORSA Automatic (or Similar)", 
      image: OpelCorsa, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      fuel: "50kWh", 
      price: 65,
      exteriorColor: "White",
      engineCapacity: "100kW",
      interiorColor: "Black",
      fuelType: "Electric",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "kia_stonic_automatic",
      name: "KIA STONIC Automatic (or Similar)", 
      image: Stonic, 
      persons: 5, 
      doors: 5, 
      suitcases: 3, 
      fuel: "64kWh", 
      price: 100,
      exteriorColor: "Yellow",
      engineCapacity: "150kW",
      interiorColor: "Black",
      fuelType: "Electric",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    }
  ],
  standard: [
    { 
      id: "nissan_quashqai_manual",
      name: "NISSAN QUASHQAI MANUAL (or Similar)", 
      image: quashqai, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      fuel: "60L", 
      price: 100,
      exteriorColor: "Black",
      engineCapacity: "1.6L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "dacia_duster_manual",
      name: "DACIA DUSTER MANUAL (or Similar)", 
      image: duster, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      fuel: "58L", 
      price: 90,
      exteriorColor: "White",
      engineCapacity: "1.5L",
      interiorColor: "Black",
      fuelType: "Diesel",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "opel_crossland_manual",
      name: "OPEL CROSSLAND MANUAL (or Similar)", 
      image: crossland, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      fuel: "57L", 
      price: 70,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "nissan_micra_automatic",
      name: "NISSAN MICRA Automatic (or Similar)", 
      image: Micra, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "nissan_micra_manual",
      name: "NISSAN MICRA Manual (or Similar)", 
      image: Micra, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 65,
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "fiat_panda_manual",
      name: "FIAT PANDA Manual (or Similar)", 
      image: Panda, 
      persons: 4, 
      doors: 4, 
      suitcases: 1, 
      fuel: "47L", 
      price: 45,
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "renault_clio_manual",
      name: "RENAULT CLIO Manual (or Similar)", 
      image: clio, 
      persons: 5, 
      doors: 5, 
      suitcases: 3, 
      fuel: "47L", 
      price: 60,
      exteriorColor: "Red",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "kia_rio_manual",
      name: "KIA RIO Manual (or Similar)", 
      image: rio, 
      persons: 5, 
      doors: 5, 
      suitcases: 3, 
      fuel: "47L", 
      price: 80,
      exteriorColor: "Blue",
      engineCapacity: "1.4L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    }
  ]
};

export const luxuryCarData = {
  jeepSUV: [
    { 
      id: "jeep_wrangler_5d_automatic",
      name: "JEEP WRANGLER 5D Automatic (or Similar)", 
      image: Wrangler5D, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 250, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "jeep_wrangler_cabrio_5d_automatic",
      name: "JEEP WRANGLER CABRIO 5D Automatic (or Similar)", 
      image: WranglerCabrio, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 150, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "nissan_quashqai_manual",
      name: "NISSAN QUASHQAI MANUAL (or Similar)", 
      image: quashqai, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 100, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "1.6L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "dacia_duster_manual",
      name: "DACIA DUSTER MANUAL (or Similar)", 
      image: duster, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 90, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "1.5L",
      interiorColor: "Black",
      fuelType: "Diesel",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "opel_crossland_manual",
      name: "OPEL CROSSLAND MANUAL (or Similar)", 
      image: crossland, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 70, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Blue",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "land_rover_discovery_automatic",
      name: "LAND ROVER DISCOVERY Automatic (or Similar)", 
      image: Discovery, 
      persons: 5, 
      doors: 4, 
      suitcases: 3, 
      price: 250, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "3.0L",
      interiorColor: "Black",
      fuelType: "Diesel",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "range_rover_sport_automatic",
      name: "RANGE ROVER SPORT Automatic (or Similar)", 
      image: RangeSport, 
      persons: 5, 
      doors: 4, 
      suitcases: 3, 
      price: 350, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "3.0L",
      interiorColor: "Black",
      fuelType: "Diesel",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "citroen_c3_aircross_automatic",
      name: "CITROEN C3 AIRCROSS Automatic (or Similar)", 
      image: C3Aircross, 
      persons: 5, 
      doors: 5, 
      suitcases: 3, 
      price: 140, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "citroen_c3_automatic",
      name: "CITROEN C3 Automatic (or Similar)", 
      image: C3, 
      persons: 5, 
      doors: 4, 
      suitcases: 3, 
      price: 110, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "citroen_cactus_c4_automatic",
      name: "CITROEN CACTUS C4 Automatic (or Similar)", 
      image: C4Cactus, 
      persons: 5, 
      doors: 4, 
      suitcases: 3, 
      price: 100, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "mini_countryman_automatic",
      name: "MINI COUNTRYMAN Automatic (or Similar)", 
      image: MiniCountryman, 
      persons: 5, 
      doors: 4, 
      suitcases: 3, 
      price: 120, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Blue",
      engineCapacity: "1.5L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "mercedes_benz_glb_2022_automatic",
      name: "MERCEDES-BENZ GLB 2022 Automatic (or Similar)", 
      image: Glb2022, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 160, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "mercedes_benz_gla_2023_automatic",
      name: "MERCEDES-BENZ GLA 2023 Automatic (or Similar)", 
      image: Gla2023, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 160, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "bmw_x1_automatic",
      name: "BMW X1 Automatic (or Similar)", 
      image: BmwX1, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 160, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "bmw_x2_automatic",
      name: "BMW X2 Automatic (or Similar)", 
      image: BmwX2, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 140, 
      category: "Jeep-SUV-Family",
      exteriorColor: "White",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "kia_sportage_auto",
      name: "KIA SPORTAGE Auto (or Similar)", 
      image: Sportage, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 100, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Red",
      engineCapacity: "1.6L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "porsche_cayenne_auto",
      name: "PORSCHE CAYENNE Auto (or Similar)", 
      image: Cayenne, 
      persons: 5, 
      doors: 5, 
      suitcases: 4, 
      price: 290, 
      category: "Jeep-SUV-Family",
      exteriorColor: "Black",
      engineCapacity: "3.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    }
  ],
  miniVans: [
    { 
      id: "citroen_berlingo_automatic",
      name: "CITROEN BERLINGO Automatic (or Similar)", 
      image: Berlingo, 
      persons: 7, 
      doors: 5, 
      suitcases: 6, 
      price: 110, 
      category: "Mini Vans",
      exteriorColor: "White",
      engineCapacity: "1.6L",
      interiorColor: "Gray",
      fuelType: "Diesel",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "fiat_doblo_manual",
      name: "FIAT DOBLO Manual (or Similar)", 
      image: Doblo, 
      persons: 7, 
      doors: 5, 
      suitcases: 6, 
      price: 100, 
      category: "Mini Vans",
      exteriorColor: "White",
      engineCapacity: "1.6L",
      interiorColor: "Gray",
      fuelType: "Diesel",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    }
  ],
  jeepWrangler: [
    { 
      id: "jeep_wrangler_5d_automatic",
      name: "JEEP WRANGLER 5D Automatic (or Similar)", 
      image: Wrangler5D, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 250, 
      category: "Jeep Wrangler",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "jeep_wrangler_manual",
      name: "JEEP WRANGLER Manual (or Similar)", 
      image: Wrangler, 
      persons: 5, 
      doors: 5, 
      suitcases: 2, 
      price: 200, 
      category: "Jeep Wrangler",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "jeep_wrangler_automatic",
      name: "JEEP WRANGLER Automatic (or Similar)", 
      image: Wrangler, 
      persons: 5, 
      doors: 5, 
      suitcases: 2, 
      price: 200, 
      category: "Jeep Wrangler",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "jeep_wrangler_sahara_automatic",
      name: "JEEP WRANGLER SAHARA Automatic (or Similar)", 
      image: WranglerSahara, 
      persons: 5, 
      doors: 5, 
      suitcases: 2, 
      price: 390, 
      category: "Jeep Wrangler",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "jeep_wrangler_4d_automatic",
      name: "JEEP WRANGLER 4D Automatic (or Similar)", 
      image: Wrangler5D, 
      persons: 5, 
      doors: 4, 
      suitcases: 2, 
      price: 250, 
      category: "Jeep Wrangler",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    }
  ],
  cabrioSpecial: [
    { 
      id: "jeep_wrangler_cabrio_5d_automatic",
      name: "JEEP WRANGLER CABRIO 5D Automatic (or Similar)", 
      image: WranglerCabrio, 
      persons: 5, 
      doors: 5, 
      suitcases: 5, 
      price: 150, 
      category: "Cabrio",
      exteriorColor: "Black",
      engineCapacity: "2.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "vw_t_roc_cabrio",
      name: "VW T-ROC CABRIO (or Similar)", 
      image: TRoc, 
      persons: 5, 
      doors: 3, 
      suitcases: 1, 
      price: 120, 
      category: "Cabrio",
      exteriorColor: "White",
      engineCapacity: "1.5L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "citroen_c1_cabrio_manual",
      name: "CITROEN C1 CABRIO Manual (or Similar)", 
      image: C1Cabrio, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      price: 80, 
      category: "Cabrio",
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "citroen_c1_cabrio_automatic",
      name: "CITROEN C1 CABRIO Automatic (or Similar)", 
      image: C1Cabrio, 
      persons: 5, 
      doors: 4, 
      suitcases: 1, 
      price: 80, 
      category: "Cabrio",
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "mini_cooper_cabrio_automatic",
      name: "MINI COOPER Cabrio Automatic (or Similar)", 
      image: MiniCooper, 
      persons: 4, 
      doors: 2, 
      suitcases: 2, 
      price: 100, 
      category: "Cabrio",
      exteriorColor: "Blue",
      engineCapacity: "1.5L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "fiat_500_automatic_cabrio",
      name: "FIAT 500 Automatic Cabrio (or Similar)", 
      image: Fiat500, 
      persons: 2, 
      doors: 3, 
      suitcases: 1, 
      price: 80, 
      category: "Cabrio",
      exteriorColor: "Red",
      engineCapacity: "1.2L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    },
    { 
      id: "smart_fortwo_cabrio_manual",
      name: "SMART ForTwo Cabrio Manual (or Similar)", 
      image: SmartForTwo, 
      persons: 2, 
      doors: 3, 
      suitcases: 1, 
      price: 80, 
      category: "Cabrio",
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Manual"
    },
    { 
      id: "smart_fortwo_cabrio_automatic",
      name: "SMART ForTwo Cabrio Automatic (or Similar)", 
      image: SmartForTwoAuto, 
      persons: 2, 
      doors: 3, 
      suitcases: 1, 
      price: 80, 
      category: "Cabrio",
      exteriorColor: "White",
      engineCapacity: "1.0L",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "2WD",
      airConditioner: true,
      transmission: "Automatic"
    }
  ]
};

export const motoData = {
  motoQuads: [
    { 
      id: "cf_moto_buggy_800cc_automatic",
      name: "CF MOTO BUGGY 800cc (or Similar)", 
      image: Buggy800, 
      persons: 2, 
      doors: 2, 
      suitcases: 1, 
      price: 120, 
      category: 'ATV-Quads',
      exteriorColor: "Red/Black",
      engineCapacity: "800cc",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: false,
      transmission: "Automatic"
    },
    { 
      id: "cf_moto_buggy_550cc_automatic",
      name: "CF MOTO BUGGY 550cc (or Similar)", 
      image: Buggy550, 
      persons: 2, 
      doors: 2, 
      suitcases: 1, 
      price: 100, 
      category: 'ATV-Quads',
      exteriorColor: "Red/Black",
      engineCapacity: "550cc",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: false,
      transmission: "Automatic"
    },
    { 
      id: "cf_moto_atv_450cc_automatic",
      name: "CF MOTO ATV 450cc (or Similar)", 
      image: ATV450, 
      persons: 2, 
      doors: 0, 
      suitcases: 0, 
      price: 80, 
      category: 'ATV-Quads',
      exteriorColor: "Red/Black",
      engineCapacity: "450cc",
      interiorColor: "Black",
      fuelType: "Gasoline",
      drivetrain: "4WD",
      airConditioner: false,
      transmission: "Automatic"
    }
  ]
};